import styled from 'styled-components';
import { toRem } from '../../../../utils';

export const HeaderSectionStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${toRem(40)};
`;
